module.exports = __webpack_public_path__ + "static/media/campaign.07aa0cad.png";